const AUTHENTICATION_TYPES = ["auth2", "apikey"];
export const IS_SANDBOX = process.env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER = process.env.REACT_APP_EXTENSION_IDENTIFIER;
export const DATA_CENTER_URL_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center_URL";
export const DATA_CENTER_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center";
export const ORG_ID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Organization_ID";

export const API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__API_KEY";

export const Z_API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZAPI_Key";

export const SERVICE_API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__SMS_API_KEY";

export const ZOHO_CONN = process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho";
export const SERVICE_CONN =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__cellcast";
export const CLIQ_CONN = process.env.REACT_APP_EXTENSION_IDENTIFIER + "__cliq";
  
export const SERVICE_NAME = "cellcast";
export const SERVICE_AUTHENTICATION_TYPE = AUTHENTICATION_TYPES[1];

export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVER_URL;
export const SERVICE_API_URL = process.env.REACT_APP_API_SERVER_URL;
